export default {
  get(key){
    if (!key) {
      key = this.keyDefault;
    }
    var value = localStorage.getItem(key);
    if (value == "\"\"" || value == "''") {
      value = "{}";
    }
    return JSON.parse(localStorage.getItem(key) || "{}");
  },
  set(option, key){
    if (!key) {
      key = this.keyDefault;
    }
    localStorage.setItem(key, JSON.stringify(option));
  },
  remove(key) {
    if (!key) {
      key = this.keyDefault;
    }
    localStorage.removeItem(key);
  },
  keyDefault: "mogo_default"
};



// WEBPACK FOOTER //
// ./src/library/localStorageHelper.js